module.exports = __webpack_public_path__ + "img/alert.68d25f66.svg";